<template>
    <div>
        <div class="dm-top box-sizing">
            <div class="dm-item">
                <span class="lab">关键字：</span>
                <span class="opt"><el-input class="inp" placeholder="请输入域名" v-model="keyword" clearable></el-input></span>
                <span class="btn"><el-button type="primary" @click="getDomainList">搜索</el-button></span>
            </div>
        </div>
        <div class="dm-mid box-sizing">
            <el-button type="success" @click="$router.push('/tabs/buyDomain')" style="font-weight: bolder;">+创建专属域名</el-button>
          <el-popconfirm title="确定删除选中的域名吗？删除后不可恢复！" @confirm="delDomains()" style="margin:0 10px">
            <el-button type="danger" slot="reference">删除选中</el-button>
          </el-popconfirm>


            <el-button type="warning" @click="replaceWord_check()">批量替换链接字符</el-button>
            <el-button type="primary" @click="addDialog=1" style="font-weight: bolder;">+绑定自有域名</el-button>
            <el-button type="primary" @click="addMoreDialog=1" style="font-weight: bolder;">批量绑定自有域名</el-button>
            剩余绑定数量：{{has_diy_domain_totals}}



            <span @click="$router.push('/tabs/buyDomain')" style="color:red;font-size: 12px;border-radius: 5px;display: inline-block;padding:2px 5px;background:orangered;color:#fff;cursor: pointer">购买更多 </span>
            <el-table v-loading="isLoading1" :data="tableData" empty-text="暂无数据" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="42"></el-table-column>
                <el-table-column prop="domain" label="域名" width="250">
                    <template slot-scope="scope">
                        <div>{{scope.row.domain}}</div>
                        <div v-if="scope.row.wx_red==0"   style="color:gray;">
                            <div class="fs12">
                                最后监控 {{scope.row.wx_check_time}}
                            </div>
                        </div>
                        <div v-if="scope.row.wx_red==1"   style="color:red;">
                            <div class="fs12">
                                停止访问  <br />
                                {{scope.row.wx_red_time}}
                            </div>
                        </div>
                        <div v-if="scope.row.wx_red==2"   style="color:blue;">
                            <div class="fs12">
                                提示访问  <br />
                                {{scope.row.wx_red_time}}
                            </div>
                        </div>
                        <div  v-if="!scope.row.wx_red || scope.row.wx_red==false" style="color:green">
                            正常
                        </div>

                    </template>

                </el-table-column>
                <el-table-column width="100" prop="links" label="已转链接" class-name="text-align"></el-table-column>
                <el-table-column label="二维码" width="75" class-name="text-align">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" content="点击查看二维码" placement="top">
                            <i class="icon iconfont iconerweima fs24" @click="showQrCode(scope.row.domain)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column prop="expire_date" width="100" label="过期时间" class-name="text-align fs12"></el-table-column>
                <el-table-column label="首页统计" class-name="text-align">
                    <template slot-scope="scope">
                        ip： <span class="gray999">{{scope.row.all_ip}}</span> <br>
                        pv： <span class="gray999">{{scope.row.all_pv}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="index_url"   label="首页跳转URL" class-name="text-align fs12">
                    <template slot-scope="scope">
                        <div>{{scope.row.index_url}}</div>
                        <div v-if="scope.row.yuan_url_status==1"   style="color:red;">
                            <div class="fs12">
                                停止访问  <br />
                                {{scope.row.yuan_url_time}}
                            </div>
                        </div>
                        <div v-if="scope.row.yuan_url_status==2"   style="color:blue;">
                            <div class="fs12">
                                提示访问  <br />
                                {{scope.row.yuan_url_time}}
                            </div>
                        </div>
                        <div  v-if="!scope.row.yuan_url_status || scope.row.yuan_url_status==false" style="color:green">
                            正常
                        </div>

                    </template>

                </el-table-column>
                <el-table-column width="150" label="备注" class-name="text-align">
                    <template slot-scope="scope">
                        <el-tooltip effect="dark" content="点击修改备注" placement="top">
                            <div class="link-mark" @click="editMark(scope.row)">{{scope.row.mark}}</div>

                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column width="150" label="操作" class-name="fs12">
                    <template slot-scope="scope">
                        <el-link  type="primary" class="fs12" @click="editIndexUrl(scope.row)" >跳转地址</el-link>&nbsp;|
                        <el-link  type="primary" @click="domainRenewal(scope.row)">续费</el-link>&nbsp;|

                      <el-link  type="primary" @click="$router.push('/tabs/exclusiveShort')">短网址</el-link>&nbsp;|
                      <el-link  type="primary" @click="$router.push('/tabs/liveCodeList')">活码</el-link>&nbsp;|
                      <el-link  type="primary" @click="$router.push('/tabs/webPage')">h5单页</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagebar" v-show="total>0">
                <el-pagination background layout="total, prev, pager, next, jumper" :total="total" @current-change="handleCurrentPage"></el-pagination>
            </div>
        </div>
        <el-dialog title="设置备注" :visible.sync="markDialog" center width="400px">
            <span>
                <el-input v-model="domainMark" clearable maxlength="20" placeholder="请输入备注"></el-input>
            </span>
            <span slot="footer">
                <el-button @click="markDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading2" @click="saveMark">确定</el-button>
            </span>
        </el-dialog>


      <el-dialog title="绑定自有域名" :visible.sync="addDialog" center width="400px">
            <span>
                <el-input v-model="diydomain" clearable  placeholder="请输入域名，如  aaaa.cn "></el-input>


            </span>
        <div style="margin-top:20px;padding:0px 15px;">
            绑定您自己在阿里云、腾讯云等注册的域名，<br>
            请做域名解析，增加一条解析记录: <br> 记录： @  (或为空)  <br>类型：cname(别名)<br>记录值为：你的域名.host.ttdwz.cc (比如要添加的是xxx.cn，则解析地址为xxx.cn.host.ttdwz.cc) ，<br><span class="red">尽量使用cdn+https回源，回源地址为 host.ttdwz.cc，回源域名一致 </span></div>

        <span slot="footer">
                <el-button @click="addDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading_add" @click="saveAdd">确定</el-button>
            </span>
      </el-dialog>

        <el-dialog title="批量绑定自有域名" :visible.sync="addMoreDialog" center width="400px">
            <span>
                <textarea v-model="diydomain2" clearable  style="width:100%;height:150px;" placeholder="请输入域名，如  aaaa.cn|跳转链接|备注 "></textarea>


            </span>
            <div style="margin-top:20px;padding:0px 15px;">
                绑定您自己在阿里云、腾讯云等注册的域名，<br>
                请做域名解析，增加一条解析记录: <br> 记录： @  (或为空)  <br>类型：cname(别名)<br>记录值为：你的域名.host.ttdwz.cc (比如要添加的是xxx.cn，则解析地址为xxx.cn.host.ttdwz.cc) ,<br><span class="red">尽量使用cdn+https回源，回源地址为 host.ttdwz.cc，回源域名一致 </span></div>

            <span slot="footer">
                <el-button @click="addMoreDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading_addmore" @click="saveAddmore">确定</el-button>
            </span>
        </el-dialog>


        <el-dialog title="域名续费" :visible.sync="renewDialog" :close-on-click-modal="false" :close-on-press-escape="false" center width="400px" @close="closeRenew">
            <span>
                <div class="expire-date">
                    <span>域名：</span>
                    <font color="red">{{renew.domain}}</font>
                    <span>，价格：</span>
                    <font color="red">{{renew.price}}</font>
                </div>
                <div class="expire-date">
                    <span>续费后到期时间：</span>
                    <font color="red">{{renew.expTime | dateFormat('YYYY-MM-DD')}}</font>
                </div>
                <div class="sel-pay">
                    <el-radio-group v-model="payType" @change="selPayType">
                        <el-radio-button :label="1" border>支付宝</el-radio-button>
                        <el-radio-button :label="2" border>微信</el-radio-button>
                    </el-radio-group>
                </div>
                <div class="expire-date">二维码有效期：{{qrExpireDate}}</div>
                <div class="qr-code-box">
                    <div class="qr-icon" v-show="payType===1||payType===2">
                        <i class="iconfont iconzhifubao zfb" v-if="!isLoading3&&payType===1"></i>
                        <i class="iconfont iconweixindenglu wx" v-if="!isLoading3&&payType===2"></i>
                    </div>
                    <div class="qr-code" ref="payQrCode">请选择支付方式</div>
                    <div class="qr-load" v-show="isLoading3">
                        <i class="el-icon-loading"></i>
                    </div>
                </div>
                <div class="expire-date">
                    <el-button type="primary" :loading="isLoading4" @click="queryPayStatus">查询支付结果</el-button>
                </div>
            </span>
        </el-dialog>
        <el-dialog title="设置主页跳转地址" :visible.sync="indexUrlDialog" center width="400px">
            <span>
                <el-input v-model="indexUrl" clearable  placeholder="请输入链接地址http开头"></el-input>
            </span>
            <span slot="footer">
                <el-button @click="indexUrlDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading2" @click="saveIndexUrl">确定</el-button>
            </span>
        </el-dialog>
        <!--查看二维码-->
        <el-dialog title="查看二维码" :visible.sync="qrCodeDialog" center :destroy-on-close="true" :modal-append-to-body="false"
                   width="400px">
            <div class="flex-row flex-center mb10">
                <div  class="fs12 pad" :class="show_diy_qr?'':'bg_blue radius-10'"  @click="show_diy_qr=0">

                    普通</div>
                <div class="fs12 pad" :class="show_diy_qr?'bg_blue radius-10':''" @click="show_diy_qr=1;show_diy_qrlogo()">自定义</div>
            </div>
            <div class="qrbox22"  v-show="show_diy_qr!=1">
                <div class="link-qr-code" ref="qrCodeDiv"></div>
            </div>

            <div v-show="show_diy_qr==1" class="flex-center flex-column" ref="qrCodeDiv2">
                <vue-qr
                        :text="codeText"
                        :size="280"
                        :margin="20"
                        colorDark="#333"
                        backgroundColor="#fff"
                        :logoSrc="lgoImg"
                        logoScale="0.21"
                        logoMargin="25px"
                ></vue-qr>
                <div class="pad">*在个人信息页面上传logo图片，即可自动生成带logo的二维码，也可点击下面继续添加
                    <el-upload
                            action=""
                            :http-request="upload_img"
                            :show-file-list="false"
                            accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF"
                            :on-success="null">
                        <div class="pad">
                            <span class="border-gray pad510 bg_gray_eee radius-5 fs12 ml10">+添加logo</span>
                        </div>
                    </el-upload>

                    <div class="flex-row">
                        <div class="flex-column mr10 flex-center" v-for="logo in logo_list">
                            <img :src="logo"  class="pic-50 radius-5 " @click="lgoImg=logo">
                            <div  title="点击删除" @click="logo_list.remove(logo);del_qrlogos()" class="fs-12">删除</div>
                        </div>
                    </div>

                </div>
            </div>
            <span slot="footer">
                <el-button type="primary" @click="savePic(show_diy_qr)">下载二维码</el-button>
            </span>
        </el-dialog>

        <!--字符替换-->
        <el-dialog title="原链接字符替换" :visible.sync="replaceWordDialog" center width="400px">
            <div class="flex-column">
                <div class="item">
                    <div class="l">原字符：</div>
                    <div class="r"><el-input v-model="old_word"  placeholder="原字符"></el-input></div>
                </div>
                <div class="item"></div>
                <div class="item mt10">
                    <div class="l">新字符：</div>
                    <div class="r"><el-input v-model="new_word"  placeholder="请输入新字符"></el-input></div>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="replaceWordDialog=false">取消</el-button>
                <el-button type="primary" :loading="isLoading5" @click="replaceWord">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';
    import VueQr from 'vue-qr'
    export default {
        name: "ExclusiveDomain",
        components:{VueQr},
        data() {
            return {
                userInfo:{},
                keyword: "",
                total: 0,
              diydomain:"",
                diydomain2:"",
              selUrlID: "",
                tableData: [],
                isLoading1: false,
                isLoading2: false,
                isLoading3: false,
                isLoading4: false,
                isLoading_add:false,
                isLoading_addmore:false,
                currentPage: 1,
                selDomainID: 0,
                markDialog: false,
                renewDialog: false,
                indexUrlDialog: false,
                qrCodeDialog: false,
                addDialog: false,
                addMoreDialog:false,
                indexUrl:"",
                qrUrl: "",
                qrInterval: null,
                qrExpireDate: "未获取",
                qrExpireSeconds: 0,


                replaceWordDialog:false,
                loadingWordDialog:false,
                isLoading5: false,
                new_word:'',
                old_word:'',

                domainMark: "",
                payType: 0,
                payOrderID: 0,
                renew: {
                    id: 0,
                    price: "",
                    domain: "",
                    expTime: "",
                },
              has_diy_domain_totals:0,
                logo_list:[],
                show_diy_qr:0,
                codeText: 'https://www.baidu.com/',
                lgoImg: '',//require('./../../assets/images/logo.png')
            }
        },
        mounted() {
            setTimeout(this.getDomainList,200);
             var  user_info = this.$storeLocal.get('userInfo');
             this.has_diy_domain_totals=user_info.has_diy_domain_totals;

            this.userInfo=this.$common.userInfo;
        },
        methods: {
            async getDomainList() {
                this.isLoading1 = true;
                const getData = {
                    p: this.currentPage,
                    keyword: this.keyword,
                };
                const {ret,data} = await this.$api.exclusive.getUserDomainList(getData);
                this.isLoading1 = false;
                if (ret === 1000){
                    this.total = Number(data.total);
                    this.tableData = data.list;
                }
            },
            async delDomains() {
              console.log('1111');
              const ids = this.selUrlID;
              console.log(ids);
              if (ids === '') {
                this.$message.error('请选择要删除的链接！');
                return;
              }
              const {ret} = await this.$api.exclusive.delUserDomain({ids: ids});
              if (ret === 1000) {
                this.$message.success('删除成功');
                this.selUrlID = "";
                await this.getDomainList();
              }
            },
          handleSelectionChange(val) {
              if (val.length === 0) {
                return;
              }
              let ids = "";
              for (const item of val) {
                ids += item.id + ",";
              }
              ids = ids.substr(0, ids.length - 1);
              this.selUrlID = ids;
            },
            async saveMark() {
                if (!this.selDomainID) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                this.isLoading2 = true;
                const postData = {
                    id: this.selDomainID,
                    mark:  this.domainMark,
                };
                const {ret} = await this.$api.exclusive.saveDomainMark(postData);
                if (ret === 1000){
                    this.isLoading2 = false;
                    this.markDialog = false;
                    this.$message.success('保存成功！');
                    this.getDomainList();
                }
            },
            showQrCode(txt) {console.log(txt)
                if (txt === '') {
                    this.$message.error('出错了！刷新试试看！');
                    return;
                }
                if(txt.match(/^http/i)==null){
                    txt='http://'+txt;
                }
                this.codeText=txt;
                this.qrCodeDialog = true;
                const $this = this;
                setTimeout(function () {
                    $this.$refs.qrCodeDiv.innerHTML = '';
                    new QRCode($this.$refs.qrCodeDiv, {
                        text: txt,
                        width: 400,
                        height: 400,
                        colorDark: "#333333", //二维码颜色
                        colorLight: "#ffffff", //二维码背景色
                        correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                    });
                }, 100);
            },
          async saveAdd() {
            if (!this.diydomain) {
              this.$message.error('请填写域名');
              return;
            }
            this.isLoading2 = true;
            const postData = {
              diydomain:  this.diydomain,
            };
            const {ret,msg} = await this.$api.exclusive.saveDiyDomain(postData);
            if (ret === 1000){
              this.isLoading_add = false;
              this.addDialog = false;
              this.$message.success('保存成功！');
              this.getDomainList();
            }else{
               //this.$message.error(msg);
            }
          },
            async saveAddmore() {
                if (!this.diydomain2) {
                    this.$message.error('请填写域名');
                    return;
                }
                this.isLoading2 = true;
                const postData = {
                    diydomain:  this.diydomain2,
                };
                const {ret,msg} = await this.$api.exclusive.saveDiyDomainMore(postData);
                if (ret === 1000){
                    this.isLoading_addmore = false;
                    this.addMoreDialog = false;
                    this.$message.success('保存成功！');
                    this.getDomainList();
                }else{
                    //this.$message.error(msg);
                }
            },


            replaceWord_check(){
                if (!this.selUrlID) {
                    this.$message.error('请先选择域名');
                    return;
                }
                this.replaceWordDialog=true;

            },
            async replaceWord() {
                const new_word = this.new_word;
                const old_word = this.old_word;

                if (!old_word) {
                    this.$message.error('请输入原字符');
                    return;
                }
                if (!new_word) {
                    this.$message.error('请输入新字符');
                    return;
                }
                const postData = {
                    id: this.selUrlID,
                    old_word: old_word,
                    new_word: new_word,
                };
                this.isLoading6 = true;
                const {ret} = await this.$api.exclusive.replaceWord(postData);
                this.isLoading6 = false;
                if (ret === 1000) {
                    this.selUrlID = '';
                    this.replaceWordDialog = false;
                    this.$message.success('替换成功！');
                    await this.getDomainList();
                }
            },

            async saveIndexUrl() {
                if (!this.selDomainID) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                this.isLoading2 = true;
                const postData = {
                    id: this.selDomainID,
                    index_url:  this.indexUrl,
                };
                const {ret} = await this.$api.exclusive.saveDomainIndexUrl(postData);
                if (ret === 1000){
                    this.isLoading2 = false;
                    this.indexUrlDialog = false;
                    this.$message.success('保存成功！');
                    this.getDomainList();
                }
            },
            async selPayType(val) {
                this.counterReset();
                this.isLoading3 = true;
                this.$refs.payQrCode.innerHTML = "";
                const postData = {
                    id: this.renew.id,
                    payType: val,
                };
                const {ret,data} = await this.$api.exclusive.renew(postData);
                this.isLoading3 = false;
                if (ret === 1000){
                    this.qrUrl = data.qrUrl;
                    this.payOrderID = data.id;
                    this.qrExpireSeconds = data.expTime;
                    this.bindQRCode();
                    this.qrCodeCountTime();
                    setTimeout(this.queryPaymentResults,1000);
                }
            },
            async queryPayStatus() {
                this.isLoading4 = true;
                const id = this.payOrderID;
                if (id === 0) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                const {ret} = await this.$api.exclusive.queryOrder({id:id});
                this.isLoading4 = false;
                if (ret === 1000){
                    this.renewDialog = false;
                    this.$alert('订单已支付成功！', '支付结果', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }else if (ret === 902){
                    this.orderTimedOut();
                }else if (ret === 903){
                    this.$message.warning('订单还未支付！请尽快支付');
                }
            },
            async queryPaymentResults() {
                const id = this.payOrderID;
                if (id === 0) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                const {ret} = await this.$api.exclusive.queryOrder({id:id});
                if (ret === 1000){
                    this.renewDialog = false;
                    this.$alert('订单已支付成功！', '支付结果', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }else if (ret === 902){
                    this.orderTimedOut();
                }else if (ret === 903){
                    if (this.renewDialog){
                        setTimeout(this.queryPaymentResults,1000);
                    }
                }
            },


            editIndexUrl(item) {
                this.indexUrlDialog = true;
                this.selDomainID = item.id;
                this.indexUrl = item.index_url;
            },
            editMark(item) {
                this.markDialog = true;
                this.selDomainID = item.id;
                this.domainMark = item.mark;
            },
            domainRenewal(item) {
                this.renew.id = item.id;
                this.renew.price = item.price;
                this.renew.domain = item.domain;
                this.renew.expTime = item.expire_time;
                this.renewDialog = true;
            },
            closeRenew() {
                this.payType = 0;
                this.renew.id = 0;
                this.$refs.payQrCode.innerHTML = "请选择支付方式";
            },
            handleCurrentPage(val) {
                this.currentPage = val;
                this.getDomainList();
            },
            bindQRCode() {
                const txt = this.qrUrl;
                if (txt === '') return;
                this.$refs.payQrCode.innerHTML = '';
                new QRCode(this.$refs.payQrCode, {
                    text: txt,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },
            qrCodeCountTime() {
                let $this = this;
                let t = $this.qrExpireSeconds;
                if ($this.qrInterval !== null) clearInterval( $this.qrInterval);
                $this.qrExpireDate = Math.floor(Math.floor(t%3600)/60)+"分"+Math.floor(t%60)+"秒";
                $this.qrInterval = setInterval(function () {t--;
                    const min = Math.floor(t%3600);
                    const minute = Math.floor(min/60);//分钟
                    const second = t%60 ;//秒
                    $this.qrExpireDate = minute+"分"+second+"秒";
                    if(t === 0){
                        $this.orderTimedOut();
                    }
                    if (!$this.renewDialog){
                        $this.counterReset();
                    }
                },1000);
            },
            orderTimedOut() {
                if (this.renewDialog){
                    this.closeRenew();
                    this.counterReset();
                    this.renewDialog = false;
                    this.$alert('支付超时！请重新续费', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }
            },
            counterReset() {
                this.qrExpireDate = "未获取";
                this.qrExpireSeconds = 0;
                if (this.qrInterval !== null) {
                    clearInterval(this.qrInterval);
                }
            },
            show_diy_qrlogo(){
                var $this=this;
                console.log($this.userInfo);
                $this.lgoImg=$this.userInfo.qr_logo;
            },
            async upload_img(file){
                var $this=this;
                this.$common.Upload(file,function(img){
                    console.log(img);
                    $this.$forceUpdate();
                    $this.lgoImg=img;
                    $this.save_qrlogos(img);

                });
            },
            async save_qrlogos(img){
                var $this=this;
                $this.logo_list.push(img);
                var dd=$this.logo_list.join('|');
                const {ret} = await $this.$api.user.saveQrlogoList({qr_logo:dd});
                if (ret === 1000){
                    this.$message.success("添加成功");
                }
            },
            async del_qrlogos(){
                var $this=this;
                var dd=$this.logo_list.join('|');
                const {ret} = await $this.$api.user.saveQrlogoList({qr_logo:dd});
                if (ret === 1000){
                    this.$message.success("添加成功");
                }
            }
        }
    }
</script>

<style scoped>
    .dm-top{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .dm-top .dm-item{
        width: 100%;
        height: 40px;
        color: #666666;
        margin-bottom: 10px;
    }
    .dm-top .dm-item .lab{
        display: inline-block;
        width: 70px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: right;
        margin-right: 10px;
        vertical-align: top;
    }
    .dm-top .dm-item .opt{
        display: inline-block;
        width: 350px;
        height: 40px;
        vertical-align: top;
    }
    .dm-top .dm-item .btn{
        display: inline-block;
        width: 70px;
        height: 40px;
        margin-left: 10px;
        vertical-align: top;
    }
    .dm-top .dm-item .inp{
        width: 350px;
    }
    .dm-mid{
        width: 100%;
        padding: 0 20px;
    }
    .dm-mid .pagebar{
        width: 100%;
        height: 52px;
        margin-top: 20px;
    }
    .link-mark{
        width: 100%;
        min-height: 23px;
    }
    .sel-pay{
        width: 100%;
        height: 40px;
        text-align: center;
        margin-bottom: 20px;
    }
    .expire-date{
        width: 100%;
        height: 40px;
        text-align: center;
    }
    .qr-code-box{
        width: 200px;
        height: 200px;
        margin: 0 auto 20px auto;
        border: 1px solid #f5f5f5;
        position: relative;
    }
    .qr-code-box .qr-icon{
        width: 40px;
        height: 40px;
        margin: -20px 0 0 -20px;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
        line-height: 40px;
        background-color: #FFFFFF;
        position: absolute;
        top: 50%;
        left: 50%;
    }
    .qr-code-box .qr-load{
        width: 100%;
        height: 100%;
        margin: -50% 0 0 -50%;
        overflow: hidden;
        text-align: center;
        line-height: 200px;
        background-color: rgba(0,0,0,0.5);
        position: absolute;
        top: 50%;
        left: 50%;
    }
    .qr-code-box .qr-icon i{
        font-size: 40px;
    }
    .qr-code-box .qr-load i{
        color: #FFFFFF;
        font-size: 28px;
    }
    .qr-code-box .qr-icon i.zfb{
        color: #1196db;
    }
    .qr-code-box .qr-icon i.wx{
        color: #00c800;
    }
    .qr-code-box .qr-code{
        width: 100%;
        height: 100%;
        text-align: center;
        line-height: 200px;
    }


    .link-qr-code {
        width: 200px;
        height: 200px;
        margin: 0 auto;
    }

</style>
